import { useMediaQuery, useTheme } from "@mui/material";
import { giftCardFormSubmit } from "./GiftCardForm-utils";
import { useLocation, useNavigate } from "react-router-dom";
export const useGiftCardForm = () => {
    var _a;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
    const navigate = useNavigate();
    const location = useLocation();
    const giftCardFormState = (_a = location.state) === null || _a === void 0 ? void 0 : _a.giftCardState;
    return {
        giftCardFormSubmit: giftCardFormSubmit(navigate),
        isMobile,
        giftCardFormState,
    };
};
